import { setGTagUser } from "@/plugins/gTag.js";

export default vm => {
  setGTagUser(vm);
};
